import { render, staticRenderFns } from "./CUAddPlant.vue?vue&type=template&id=0e96f2b2&scoped=true&"
import script from "./CUAddPlant.vue?vue&type=script&lang=js&"
export * from "./CUAddPlant.vue?vue&type=script&lang=js&"
import style0 from "./CUAddPlant.vue?vue&type=style&index=0&id=0e96f2b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96f2b2",
  null
  
)

export default component.exports